import styled from "styled-components";
import colors from "../../../styles/colors";

export const HTMLContentContainer = styled.div`
  border: 0.15rem dotted ${colors.darkgrey};
  padding: 0.5rem;
  margin: 0.5rem 0rem;
  position: relative;

  &:hover {
    border-color: transparent;
  }
`;

export const EditButton = styled.button`
  background-color: rgba(255, 255, 255, 0.65);
  cursor: pointer;
  align-items: center;
  display: flex;
  font-size: 2.5rem;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 999;
  outline: none;

  &:focus {
    outline: none;
  }
`;

export const EditPlaceholder = styled.div`
  font-size: 1.75rem;
  margin: 1.25rem 0rem;
  text-align: center;
`;
